<template>
    <div id="LabDiv">
        <HeaderVue />
        <div class="search-section">
            <div class="container">
                <div class="row">
                    <!--<div class="col-lg-9">
                        <h2>Lab Test Selected</h2>
                        <span class="badge badge-primary mb-1"  v-if="selectedProfileAndTest" v-for="(selectedTest, index) in selectedProfileAndTest" :key='index'>{{selectedTest.name}}</span>
                        <span class="mb-1" v-else>No Tests/Profiles</span>
                    </div>
                    <div class="col-lg-3">
                        <button class="btn btn-light full-width float-right btn-left-icon mt-2" v-on:click="goSearch()"><i class="material-icons">arrow_back</i> Modify Search</button>
                    </div>-->
                    <!--<div class="col-sm-12 col-lg-10">
                        <div class="form-group mb-0">
                            <label class="ft-s-15">Add one or more lab tests</label>
                            <div class="input-group mb-2" id="test-option" v-bind:class="{ 'focused-search': (searchtext != '') }">
                                <input type="text" class="form-control rounded search-terms pl-35" placeholder="+ Add Test" aria-label="" name="x" list="mycarousel" autocomplete="off" minlength="3" 
                                  v-model="searchtext" 
                                  v-on:keyup.enter="getProfileAndTests()" 
                                  v-on:change="getProfileAndTests()">
                                <img src="static/images/search.svg" class="search-img" alt="">
                                <div class="test-option">
                                    <div class="popular-test focus-search">
                                        <h5>Test</h5>
                                        <ul>
                                            <li v-for="(test, index) in searchContent.test" :key="index" v-on:click="addTestFromDropdown($event, test)">
                                              <p class="m-0 capitalize">
                                                <i class="fa fa-plus mr-2"></i> 
                                                {{test.name}}
                                                <i v-if="test.isSelected === 1" class="fa fa-circle green-color" style="font-size: 11px; margin-left:3px"></i>
                                              </p>
                                              
                                              <p class="test-key m-0 pl-4" v-if="test.Keywords">Also known as: <span class="capitalize">{{test.Keywords}}</span></p>
                                            </li>
                                            <li v-if="searchContent.test.length === 0"> --- No Tests ---</li>
                                        </ul>
                                    </div>
                                    <div class="profile-test">
                                        <h5>Profile</h5>
                                        <ul>
                                            <li v-for="(profile, index) in searchContent.profile" :key="index" v-on:click="addTestFromDropdown($event, profile)">
                                              <p class="m-0 capitalize">
                                                  <i class="fa fa-plus mr-2"></i>
                                                    {{profile.name}}
                                                <i v-if="profile.isSelected === 1" class="fa fa-circle green-color" style="font-size: 11px; margin-left:3px"></i>
                                               </p>
                                              <p class="test-key m-0 pl-4" v-if="profile.Keywords">Also known as: <span class="capitalize">{{profile.Keywords}}</span></p>
                                              <p class="test-key m-0 pl-4" v-if="profile.ProfileTests">Tests: <span class="capitalize">{{profile.ProfileTests}}</span></p>
                                            </li>
                                            <li v-if="searchContent.profile.length === 0"> --- No Profiles --- </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="test-option" v-if="isSearchLoading">
                                  {{ isSearchLoading }}
                                </div>
                            </div>
                            <div v-bind:class="{ 'testProfileSearch': (searchtext != '') }" >
                              <span class="badge badge-primary mb-1" v-for="(sel, index) in selectedProfileAndTest" :key="index">
                                  <span class="capitalize">{{sel.name}}</span>
                                  <i class="material-icons float-right" @click.prevent="removeSelectedItems(sel)">close</i>
                              </span>
                              <span class="mb-1 ft-s-15" v-if="selectedProfileAndTest.length <= 0" >
                                No test or profile selected
                              </span>
                            </div>
                        </div>
                    </div>-->
                    <div class="col-sm-12 col-lg-5">
                        <div class="form-group">
                            <label>Select City & Locality</label>
                            <div class="input-group mb-2 w-40 float-left">
                                 <select class="form-control remove-right-radius" v-model="selectedCity" v-on:click="onBlurKey=false;" v-on:change="onCityChange()">
                                    <option v-for="(city, index) in locationMasterList" :key="index" v-bind:value="city">{{city.cityName}}</option>
                                 </select>
                                 <!--<input type="text" class="form-control col-sm-7" placeholder="Choose Locality" aria-label="" >-->
                                 
                                  
                                <!--<span class="red-color" >
                                  <span class="ft-s-15" v-if="pincode ? pincode.length !== 6 : true">Locality is Required</span>
                                </span>-->
                            </div>
                            <div class="input-group mb-2 w-60 float-left" id="localitySearch">
                                  <input type="text" class="form-control remove-left-radius" 
                                          ref="pincode" 
                                          placeholder="Choose Locality" 
                                          aria-label="" name="x" 
                                          list="mycarousel" 
                                          autocomplete="off" 
                                          minlength="3" 
                                          v-model="query"
                                          v-on:blur="closeBlock()"
                                          v-on:keyup="showHideLocation()"
                                          v-on:keyup.enter="showHideLocation()" 
                                          v-on:focus="$refs.pincode.select();searchtext=''; query=''; onBlurKey=true; showHideLocation();" >
                                  <div  class="test-option full-width mt-4 scrollbar locality" style="display: block" v-if="onBlurKey">
                                      <div class="popular-test focus-search p-0">
                                          <ul class="p-0 m-0">
                                              <li class="p-2" style="border-bottom: 1px;" v-for="(item, index) in locationList" :key="index" v-on:click="selectLocation(item)">
                                                  <span>{{item.locationName}}
                                                    <!--<br>
                                                  <span style="color: grey; font-size: 12px">{{item.City.cityName}}</span>-->
                                                  </span>
                                              </li>
                                              <li v-if="locationList.length === 0" class="text-center"> --- No Locations ---</li>
                                          </ul>
                                      </div>
                                  </div>
                                </div>
                        </div>
                    </div>
                    <!--<div class="col-sm-6 col-lg-3">
                        <div class="form-group">
                            <label>Locality</label>
                            <div class="input-group mb-2">
                             
                                <input type="text" class="form-control" placeholder="" aria-label="">
                                <select class="form-control">
                                    <option value="1">Chennai</option>
                                    <option value="2">Bangalore</option>
                                 </select>
                            </div>
                        </div>
                    </div>-->
                    <div class="col-sm-12 col-lg-7">
                        <div class="form-group mb-0">
                            <label class="ft-s-15">Search or Add lab tests</label>
                            <div class="input-group mb-2" id="test-option" v-bind:class="{ 'focused-search': (searchtext != '') }">
                                <input type="text" class="form-control rounded search-terms pl-35" placeholder="Search or Add" aria-label="" name="x" list="mycarousel" autocomplete="off" minlength="3" 
                                  v-model="searchtext" 
                                  v-on:keyup.enter="getProfileAndTests()" 
                                  v-on:keyup="getProfileAndTests()" 
                                  v-on:change="getProfileAndTests()">
                                <img src="static/images/search.svg" class="search-img" alt="">
                                <div class="test-option">
                                    <div class="popular-test focus-search">
                                        <h5>Test</h5>
                                        <ul>
                                            <li v-for="(test, index) in searchContent.test" :key="index" v-on:click="addTestFromDropdown($event, test)">
                                              <p class="m-0 capitalize">
                                                <i class="fa fa-plus mr-2"></i> 
                                                {{test.name}}
                                                <i v-if="test.isSelected === 1" class="fa fa-circle green-color" style="font-size: 11px; margin-left:3px"></i>
                                              </p>
                                              
                                              <p class="test-key m-0 pl-4" v-if="test.Keywords"><strong class="black-color">Also known as:</strong> <span class="capitalize">{{test.Keywords}}</span></p>
                                            </li>
                                            <li v-if="searchContent.test.length === 0"> --- No Tests ---</li>
                                        </ul>
                                    </div>
                                    <div class="profile-test">
                                        <h5>Package</h5>
                                        <ul>
                                            <li v-for="(profile, index) in searchContent.profile" :key="index" v-on:click="addTestFromDropdown($event, profile)">
                                              <p class="m-0 capitalize">
                                                  <i class="fa fa-plus mr-2"></i>
                                                    {{profile.name}}
                                                <i v-if="profile.isSelected === 1" class="fa fa-circle green-color" style="font-size: 11px; margin-left:3px"></i>
                                               </p>
                                              <p class="test-key m-0 pl-4" v-if="(profile.testCount && profile.testCount > 0) || (profile.includedProfiles && profile.includedProfiles.count > 0)">
                                                <b>Includes {{getIncudedTestAndProfilePop(profile)}} </b> 
                                              </p>
                                            </li>
                                            <li v-if="searchContent.profile.length === 0"> --- No Profiles --- </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="test-option" v-if="isSearchLoading">
                                  {{ isSearchLoading }}
                                </div>
                            </div>
                            <div v-bind:class="{ 'testProfileSearch': (searchtext != '') }" >
                              <span class="badge badge-primary mb-1" v-for="(sel, index) in selectedProfileAndTest" :key="index">
                                  <span class="capitalize">{{sel.name}}</span>
                                  <i class="material-icons float-right" @click.prevent="removeSelectedItems(sel)">close</i>
                              </span>
                              <span class="mb-1 ft-s-15" v-if="selectedProfileAndTest.length <= 0" >
                                No test or profile selected
                              </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- search-section -->
        <div class="portal-section">
            <div v-bind:class="{'container-fluid' : selectedProfileAndTest && selectedProfileAndTest.length > 0 , 'container' : !selectedProfileAndTest || selectedProfileAndTest.length <= 0}">
                <div class="row">
                  <div class="col-sm-7 offset-sm-3">
                    <div class="row">
                          <div class="col-sm-9 mb-0">
                              <!--<h5 class="page-title black-color">Select Laboratory</h5>-->
                              <p class="mt-1 mb-0" v-if="labContent && labLists.length > 0 && !isLabLoading">Showing <b class="black-color">{{labLists.length}} Labs </b> in <b class="black-color">{{$localStorage.get('location') ? $localStorage.get('location').locationName : (selectedCity ? selectedCity.cityName : '') }} </b>, starting from {{'Rs.'+lowestCost}}</p>
                          </div>
                          <div class="col-sm-3 mb-0" v-if="labContent && labLists.length > 0 && !isLabLoading" >
                              <select class="form-control form-control-sm mb-3" v-model="sortBy" v-on:change="labSortOrder()" >
                                  <option value="1">Price Low to High</option>
                                  <option value="2">Price High to Low</option>
                                  <!--<option value="3">Nearest</option>-->
                                  <option value="3">Ratings</option>
                              </select>
                          </div> 
                      </div>
                  </div>
                </div>
                <div class="row">
                    <div class="col-sm-3 d-none d-sm-block" v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0">
                      <div class="card">
                            <div class="card-header">
                                Popular Packages
                            </div>
                            <div class="card-body" >
                                <ul class="test-list" v-if="(popularTests.profile)">
                                    <li class="pd_10 cursor-p" v-for="(data, index) in popularTests.profile.slice(0, 5)" :key="index" >
                                        <span v-on:click="addTestFromDropdown($event, data)">
                                          <i class="fa fa-plus mr-2"></i> 
                                          {{data.name}}
                                        </span>
                                        <span class="blue-color list-popup" v-on:click="openPopularProfileTestList(data)">
                                            (includes {{getIncudedTestAndProfilePopular(data)}})
                                        </span>
                                        <i v-if="data.isSelected === 1" class="fa fa-circle green-color test-active-font"></i>
                                    </li>
                                </ul>
                                <ul class="lab-test" v-else >
                                    <li>
                                      Loading...
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="card mt-3">
                            <div class="card-header">
                                Popular Tests
                            </div>
                            <div class="card-body">
                                <ul class="test-list" v-if="(popularTests.test)">
                                    <li class="pd_10 cursor-p" v-for="(data, index) in popularTests.test.slice(0, 5)" :key="index" v-on:click="addTestFromDropdown($event, data)">
                                        <i class="fa fa-plus mr-2"></i> 
                                        {{data.name}}
                                        <i v-if="data.isSelected === 1" class="fa fa-circle green-color test-active-font" ></i>
                                    </li>
                                </ul>
                                <ul class="lab-test" v-else >
                                    <li>
                                      Loading...
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-sm-7" v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0">
                      <div class="lab" v-if="selectedProfileAndTest[0].info && selectedProfileAndTest[0].info.length > 0">
                            <div class="display-flex">
                                <div class="row">
                                     <div class="col-12 collapse-group">
                                          <h4 class="text-black capitalize profile_detail fs-14">{{selectedProfileAndTest[0].name}}</h4>
                                          <p class="p-profile-detail">
                                            {{selectedProfileAndTest[0].info.length > 0 ? selectedProfileAndTest[0].info : '' }}
                                          </p>
                                      </div>
                                </div>
                            </div>
                            <div class="clearfix">
                            </div>
                        </div>
                        <div class="lab" v-for="(lab, index) in limitBy(labLists, labLimit)" :key='index'>
                            <div class="display-flex">
                                <div class="flex-box">
                                    <div class="lab-logo">
                                        <img v-if="lab.logo && lab.logo.length > 0" :src="lab.logo" />
                                    </div>
                                    <div class="lab-rating">
                                        <ul>
                                            <li v-for="stars in parseInt(lab.rating)">
                                                <i class="material-icons">star</i>
                                            </li>
                                            <!--<li>
                                                <i class="material-icons">star_half</i>
                                            </li>-->
                                            <li v-for="star_borders in 5-parseInt(lab.rating)">
                                                <i class="material-icons">star_border</i>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="flex-box">
                                    <h6 class="black-color mb-0">{{lab.labName}}</h6>
                                    <p class="mb-0">
                                      <span class="mr-3">
                                        <i class="fa fa-map-marker green-color mr-1" aria-hidden="true"></i>
                                        {{lab.branch.branchLocation}}
                                      </span>
                                      <!--<span class="mr-3">
                                        <i class="fa fa-bus green-color" aria-hidden="true"></i>
                                        {{lab.branch.distance + ' Kms'}}
                                      </span>-->
                                    </p>
                                    <h6 class="pickup-label">
                                        <span class="badge badge-success">Free Home Sample Pickup</span>
                                    </h6>
                                    <p>
                                        <span v-for="(tl, key) in lab.labTestList" :key='key'>
                                          <span class="selected-test">{{ tl.aliasName }}</span>
                                          <span class="selected-test" v-if="tl.testId === 0">
                                              <span class="blue-color list-popup" v-if="tl.testId === 0" v-on:click="openProfileTestList(tl.aliasName, tl.testInfo, tl)">
                                                  (includes {{getIncudedTestAndProfile(tl)}} )
                                              </span>
                                          </span>
                                          <span v-bind:id="key" v-if="(lab.labTestList.length > 1 && (key) != (lab.labTestList.length-1))">&nbsp;|&nbsp;</span>
                                        </span>
                                    </p>
                                    <!-- <h5 class="mt-1 mb-0 price-tag">
                                        <span class="red-color strip-text">Rs. 8000</span> Rs. 2199
                                    </h5>
                                    <a class="blue-color">Price Breakup</a> -->
                                </div>
                            </div>
                            <div class="clearfix">
                                <div class="float-left" v-if="lab.certificationList.length > 0">
                                    <span class="mb-2">Lab Certified with</span>
                                    <div class="clearfix"></div>
                                    <ul class="lab-certificate mt-3">
                                        <li v-for="(cert, index) in lab.certificationList" :key='index'>
                                          <img src="static/images/certifi01.jpg" v-if="(cert.labCertificateImageId === 1)" alt="">
                                          <img src="static/images/certifi03.jpg" v-if="(cert.labCertificateImageId === 2)" alt="">
                                          <img src="static/images/certifi02.jpg" v-if="(cert.labCertificateImageId === 3)" alt="">
                                      </li>
                                    </ul>
                                </div>
                                <div class="float-right">
                                    <div class="clearfix"></div>
                                    <h5 class="float-lg-right mt-1 mb-0 price-tag">
                                        <span class="red-color strip-text" v-if="(lab.actualCost > lab.ourCost)">Rs. {{lab.actualCost}}</span>
                                        <strong>Rs. {{lab.ourCost}}</strong>
                                    </h5>
                                    <div class="clearfix"></div>
                                     <div class="dropup">
                                        <a class="float-right mt-1 mb-3 blue-color dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Price Breakup</a>
                                        <div class="dropdown-menu dropdown-menu-right p-3">
                                            <div class="table-responsive">
                                                <table class="price-breake fs-13">
                                                    <tr v-for="(tl, key) in lab.labTestList" :key='key'>
                                                        <td class="text-nowrap">{{tl.aliasName}}</td>
                                                        <td class="text-nowrap">
                                                          <h5 class="float-right mt-1 mb-0 price-tag price-tag price-breakeup">
                                                              <span class="red-color strip-text" v-if="(tl.acutalPrice > tl.ourPrice)">Rs. {{tl.acutalPrice}}</span> Rs. {{tl.ourPrice}}
                                                          </h5>
                                                            <!--<span class="red-color strip-text" v-if="(tl.acutalPrice > tl.ourPrice)">Rs. {{tl.acutalPrice}}</span>-->
                                                        </td>
                                                        <!--<td class="text-nowrap">Rs. {{tl.ourPrice}}</td>-->
                                                    </tr>
                                                    <tr class="grey-color border-top">
                                                        <td class="text-nowrap bo">Sub Total</td>
                                                        <!--<td class="text-nowrap"></td>-->
                                                        <td class="text-nowrap">
                                                          <h5 class="float-right mt-1 mb-0 price-tag price-tag">
                                                              <!--<span class="red-color strip-text" v-if="lab.actualCost > lab.ourCost"> Rs. {{lab.actualCost}}</span> -->
                                                                Rs. {{lab.ourCost}}
                                                          </h5>
                                                          <!--Rs. {{lab.ourCost}}-->
                                                          </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <button v-if="$localStorage.get('sl') && $localStorage.get('sl').labId === lab.labId" class="btn btn-primary full-width" v-on:click="goChooseDate(lab)">book appointment</button>
                                    <button v-if="$localStorage.get('sl') && $localStorage.get('sl').labId !== lab.labId" class="btn btn-primary full-width" v-on:click="goChooseDate(lab)">book appointment</button>
                                   
                                    <button v-if="!$localStorage.get('sl')" class="btn btn-primary full-width" v-on:click="goChooseDate(lab)">book appointment</button>
                                    <!--<button class="btn btn-primary full-width" onclick="location.href='health-cart.html'">Book Appointment</button>-->
                                </div>
                            </div>
                        </div>
                        <div class="card  mt-3" v-if="labLists.length <= 0">
                            <div class="card-body" >
                              <!--<div v-if="labLists.length <= 0 && selectedProfileAndTest.length > 0 && !isLabLoading" class="no-labs text-center mt-4">
                                <img src="static/images/lab-flask.png" alt="">
                                <p>No Labs found labs in {{$localStorage.get('sc').cityName}}</p>
                              </div>-->
                              <div v-if="labLists.length <= 0 && !isLabLoading" class="no-labs text-center mt-4">
                                <img src="static/images/lab-flask.png" alt="">
                                <p>No Labs found for your tests in {{selectedCity.cityName ? selectedCity.cityName : ''}}</p>
                              </div>
                              <div v-if="labLists.length <= 0 && isLabLoading" class="no-labs text-center mt-4">
                                <img src="static/images/lab-flask.png" alt="">
                                <p>Loading...</p>
                              </div>
                            </div>
                        </div>
                        <!--<div v-if="labLists.length <= 0 && !isLabLoading" class="no-labs text-center mt-4">
                          <img src="static/images/lab-flask.png" alt="">
                          <p>{{labSearchContent}}</p>
                        </div>
                        <div v-if="labLists.length <= 0 && isLabLoading" class="no-labs text-center mt-4">
                          <img src="static/images/lab-flask.png" alt="">
                          <p>Loading...</p>
                        </div>-->
                        
                    </div>
                    <div class="col-sm-2" v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0">
                        <a  v-for="(sideBanner , index) in sideBannerAds" v-on:click="adsRedirect(sideBanner.url)">
                          <img v-bind:src="sideBanner.src" class="w-100" v-bind:class="{'mt-3' : (index > 0)}" alt="" >
                        </a>
                        <!--<a v-on:click="adsRedirect('/labs/chennai/comprehensive_health_checkup')">
                          <img src="static/images/banner/comprehensive.jpg" class="w-100 mt-3" alt="">
                        </a>
                        <a v-on:click="adsRedirect('/labs/chennai/General_Health_Checkup')">
                          <img src="static/images/banner/general.jpg" class="w-100 mt-3" alt="">
                        </a>
                        <a v-on:click="adsRedirect('/labs/chennai/Hypertension_checkup')">
                          <img src="static/images/banner/hyper.jpg" class="w-100 mt-3" alt="" >
                        </a>-->
                        <!-- <img src="images/ads.jpg" class="w-100" alt=""> -->
                        <!--<button onclick="location.href='index.html'" class="btn btn-outline-primary full-width mt-3">Read More</button>-->
                    </div>
                    <div class="col-sm-12 mt-3" v-if="!selectedProfileAndTest || selectedProfileAndTest.length === 0">
                        <p> Please Choose one or more Profile/Test to show labs</p>
                    </div>
                    <div class="col-sm-5  <mt-0></mt-0>" v-if="!selectedProfileAndTest || selectedProfileAndTest.length === 0">
                      <div class="card">
                          <div class="card-header">
                              Popular Packages
                          </div>
                          <div class="card-body" >
                              <ul class="test-list" v-if="(popularTests.profile)">
                                  <li class="pd_10 cursor-p" v-for="(data, index) in popularTests.profile.slice(0, 10)" :key="index" >
                                      <span v-on:click="addTestFromDropdown($event, data)">
                                        <i class="fa fa-plus mr-2"></i> 
                                        {{data.name}}
                                      </span>
                                      <span class="blue-color list-popup" v-on:click="openPopularProfileTestList(data)">
                                          (includes {{getIncudedTestAndProfilePopular(data)}})
                                      </span>
                                      <i v-if="data.isSelected === 1" class="fa fa-circle green-color test-active-font"></i>
                                  </li>
                              </ul>
                              <ul class="lab-test" v-else >
                                  <li>
                                    Loading...
                                  </li>
                              </ul>
                          </div>
                      </div>
                    </div>
                    <div class="col-sm-4  mt-0" v-if="!selectedProfileAndTest || selectedProfileAndTest.length === 0">
                        <div class="card">
                            <div class="card-header">
                                Popular Tests
                            </div>
                            <div class="card-body">
                                <ul class="test-list" v-if="(popularTests.test)">
                                    <li class="pd_10 cursor-p" v-for="(data, index) in popularTests.test.slice(0, 10)" :key="index" v-on:click="addTestFromDropdown($event, data)">
                                        <i class="fa fa-plus mr-2"></i> 
                                        {{data.name}}
                                        <i v-if="data.isSelected === 1" class="fa fa-circle green-color test-active-font" ></i>
                                    </li>
                                </ul>
                                <ul class="lab-test" v-else >
                                    <li>
                                      Loading...
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-sm-3 mt-0" v-if="!selectedProfileAndTest || selectedProfileAndTest.length === 0">
                        <a  v-for="(sideBanner , index) in sideBannerAds" v-on:click="adsRedirect(sideBanner.url)">
                          <img v-bind:src="sideBanner.src" class="w-100" v-bind:class="{'mt-3' : (index > 0)}" alt="" >
                        </a>
                        <!--<a v-on:click="adsRedirect('/labs/chennai/comprehensive_health_checkup')">
                          <img src="static/images/banner/comprehensive.jpg" class="w-100 mt-3" alt="">
                        </a>
                        <a v-on:click="adsRedirect('/labs/chennai/General_Health_Checkup')">
                          <img src="static/images/banner/general.jpg" class="w-100 mt-3" alt="">
                        </a>
                        <a v-on:click="adsRedirect('/labs/chennai/Hypertension_checkup')">
                          <img src="static/images/banner/hyper.jpg" class="w-100 mt-3" alt="" >
                        </a>-->
                        <!-- <img src="images/ads.jpg" class="w-100" alt=""> -->
                        <!--<button onclick="location.href='index.html'" class="btn btn-outline-primary full-width mt-3">Read More</button>-->
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 offset-5">
                        <button class="btn btn-outline-primary full-width" v-if="labLists.length >labLimit" v-on:click="loadMore()">Show more Labs ({{labLists.length - labLimit}})</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="modal fade bd-example-modal-lg" id="test-popup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
          aria-hidden="true">
            <div class="modal-dialog  modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{clickedProfileDetails.aliasName}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p v-if="clickedProfileDetails.patientInstruction && clickedProfileDetails.patientInstruction.length > 0">Patient Instruction:</p>
                        <p class="black-color" v-if="clickedProfileDetails.patientInstruction && clickedProfileDetails.patientInstruction.length > 0">{{clickedProfileDetails.patientInstruction}}</p>

                        <p v-bind:class="{'mt-4' : (clickedProfileDetails.patientInstruction && clickedProfileDetails.patientInstruction.length > 0 ) }" v-if="clickedProfileTests.length > 0 || (clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0)">Included Tests (<span style="font-size: 12px">{{getIncudedTestAndProfilePop(clickedProfileDetails)}}</span>): </p>
                        <div class="black-color row included-profiles" v-if="clickedProfileTests.length > 0 || (clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0) ">
                            <div class="col-sm-6" >
                                <div id="accordion" role="tablist" v-if="(clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0)">
                                  <div class="card" v-for="(inclProf, index) in clickedProfileDetails.includedProfiles.data" :key='index'>
                                      <div class="card-header" role="tab" id="headingOne">
                                          <h5 class="mb-0">
                                              <a class="collapsed" data-toggle="collapse" v-bind:href="'#collapseTwo'+inclProf.panelId" aria-expanded="true" aria-controls="collapseTwo">
                                                  {{inclProf.panelName+' (includes '+ inclProf.ProfileTests.length +' Tests)'}}
                                                  <i class="material-icons float-right"></i>
                                              </a>
                                          </h5>
                                      </div>

                                      <div v-bind:id="'collapseTwo'+inclProf.panelId" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                                          <div class="pl-4">
                                              <span class="mb-2" v-for="(incTest, index) in inclProf.ProfileTests" :key='index'>{{incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : '')}}<br></span>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            <!--</div>
                            <div class="col-sm-6">-->
                                <div id="accordion" role="tablist">
                                  <div class="card" v-for="(cli, index) in clickedProfileTestFirst" :key='index'>
                                      <div class="card-header" role="tab" id="headingOne">
                                          <h5 class="mb-0">
                                              <a>
                                                  {{cli}}
                                              </a>
                                          </h5>
                                      </div>
                                  </div>
                              </div>
                            </div>
                            <div class="col-sm-6">
                                <div id="accordion" role="tablist">
                                  <div class="card" v-for="(cli, index) in clickedProfileTestSecond" :key='index'>
                                      <div class="card-header" role="tab" id="headingOne">
                                          <h5 class="mb-0">
                                              <a class="collapsed">
                                                  {{cli}}
                                              </a>
                                          </h5>
                                      </div>
                                  </div>
                              </div>
                            </div>
                            <!--<div class="col-sm-6">
                                <p v-for="(cli, index) in clickedProfileTestFirst" :key='index'>{{cli}}</p>
                            </div>
                            <div class="col-sm-6">
                                <p v-for="(cli, index) in clickedProfileTestSecond" :key='index'>{{cli}}</p>
                            </div>-->
                        </div>
                        <div class="black-color" v-else>
                            <p> -- No tests available -- </p>
                        </div>
                        <!--<div class="profile-test portal-section" v-if="clickedProfileDetails.package == 1 && clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0">
                          <h5>Includes {{clickedProfileDetails.includedProfiles.count}} Profile</h5>
                          <div id="accordion" role="tablist">
                              <div class="card" v-for="(inclProf, index) in clickedProfileDetails.includedProfiles.data" :key='index'>
                                  <div class="card-header" role="tab" id="headingOne">
                                      <h5 class="mb-0">
                                          <a class="collapsed" data-toggle="collapse" v-bind:href="'#collapseOne'+inclProf.panelId" aria-expanded="true" aria-controls="collapseOne">
                                              {{inclProf.aliasName+'(includes '+ inclProf.ProfileTests.length +'    Tests )'}}
                                              <i class="material-icons float-right"></i>
                                          </a>
                                      </h5>
                                  </div>

                                  <div v-bind:id="'collapseOne'+inclProf.panelId" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                                      <div class="pl-4">
                                          <span class="mb-2" v-for="(incTest, index) in inclProf.ProfileTests" :key='index'>{{incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : '')}}<br></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade bd-example-modal-lg" id="lab_test-popup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
          aria-hidden="true">
            <div class="modal-dialog  modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{clickedProfileDetails.aliasName}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p v-if="clickedProfileDetails.patientInstruction && clickedProfileDetails.patientInstruction.length > 0">Patient Instruction:</p>
                        <p class="black-color" v-if="clickedProfileDetails.patientInstruction && clickedProfileDetails.patientInstruction.length > 0">{{clickedProfileDetails.patientInstruction}}</p>

                        <p v-bind:class="{'mt-4' : (clickedProfileDetails.patientInstruction && clickedProfileDetails.patientInstruction.length > 0 ) }" v-if="clickedProfileTests.length > 0 || (clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0)">Included Tests (<span style="font-size: 12px">{{getIncudedTestAndProfile(clickedProfileDetails)}}</span>): </p>
                        <div class="black-color row included-profiles" v-if="clickedProfileTests.length > 0 || (clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0) ">
                            <div class="col-sm-6" >
                                <div id="accordion" role="tablist" v-if="(clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0)">
                                  <div class="card" v-for="(inclProf, index) in clickedProfileDetails.includedProfiles.data" :key='index'>
                                      <div class="card-header" role="tab" id="headingOne">
                                          <h5 class="mb-0">
                                              <a class="collapsed" data-toggle="collapse" v-bind:href="'#collapseOne'+inclProf.panelId" aria-expanded="true" aria-controls="collapseOne">
                                                  {{inclProf.aliasName+' (includes '+ inclProf.ProfileTests.length +' Tests)'}}
                                                  <i class="material-icons float-right"></i>
                                              </a>
                                          </h5>
                                      </div>

                                      <div v-bind:id="'collapseOne'+inclProf.panelId" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                                          <div class="pl-4">
                                              <span class="mb-2" v-for="(incTest, index) in inclProf.ProfileTests" :key='index'>{{incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : '')}}<br></span>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            <!--</div>
                            <div class="col-sm-6">-->
                                <div id="accordion" role="tablist">
                                  <div class="card" v-for="(cli, index) in clickedProfileTestFirst" :key='index'>
                                      <div class="card-header" role="tab" id="headingOne">
                                          <h5 class="mb-0">
                                              <a class="collapsed">
                                                  {{cli}}
                                              </a>
                                          </h5>
                                      </div>
                                  </div>
                              </div>
                            </div>
                            <div class="col-sm-6">
                                <div id="accordion" role="tablist">
                                  <div class="card" v-for="(cli, index) in clickedProfileTestSecond" :key='index'>
                                      <div class="card-header" role="tab" id="headingOne">
                                          <h5 class="mb-0">
                                              <a class="collapsed">
                                                  {{cli}}
                                              </a>
                                          </h5>
                                      </div>
                                  </div>
                              </div>
                            </div>
                            <!--<div class="col-sm-6">
                                <p v-for="(cli, index) in clickedProfileTestFirst" :key='index'>{{cli}}</p>
                            </div>
                            <div class="col-sm-6">
                                <p v-for="(cli, index) in clickedProfileTestSecond" :key='index'>{{cli}}</p>
                            </div>-->
                        </div>
                        <div class="black-color" v-else>
                            <p> -- No tests available -- </p>
                        </div>
                        <!--<div class="profile-test portal-section" v-if="clickedProfileDetails.package == 1 && clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0">
                          <h5>Includes {{clickedProfileDetails.includedProfiles.count}} Profile</h5>
                          <div id="accordion" role="tablist">
                              <div class="card" v-for="(inclProf, index) in clickedProfileDetails.includedProfiles.data" :key='index'>
                                  <div class="card-header" role="tab" id="headingOne">
                                      <h5 class="mb-0">
                                          <a class="collapsed" data-toggle="collapse" v-bind:href="'#collapseOne'+inclProf.panelId" aria-expanded="true" aria-controls="collapseOne">
                                              {{inclProf.aliasName+'(includes '+ inclProf.ProfileTests.length +'    Tests )'}}
                                              <i class="material-icons float-right"></i>
                                          </a>
                                      </h5>
                                  </div>

                                  <div v-bind:id="'collapseOne'+inclProf.panelId" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                                      <div class="pl-4">
                                          <span class="mb-2" v-for="(incTest, index) in inclProf.ProfileTests" :key='index'>{{incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : '')}}<br></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>-->
                    </div>
                </div>
            </div>
        </div>
        <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'
import _ from 'underscore'
import Vue from 'vue'
import Fuse from 'fuse.js'
export default {
  name: 'ChooseLab',
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    // if (!this.$localStorage.get('pincode') || !this.$localStorage.get('st') || this.$localStorage.get('st').length === 0) {
    //   this.$router.push({ path: '/test' })
    //   return false
    // }
  },
  data () {
    return {
      labLimit: 10,
      labTests: {},
      labLists: [],
      selectedLab: [],
      isLabLoading: false,
      labDetails: '',
      selectedProfileAndTest: [],
      totalLabs: [],
      limitedLabs: [],
      _s3BucketUrl: '',
      clickedProfileName: '',
      clickedProfileDetails: [],
      clickedProfileTests: [],
      clickedProfileTestFirst: [],
      clickedProfileTestSecond: [],
      labSearchContent: 'Loading...',
      labContent: false,
      pincodeButton: false,
      ProfileAndTest: [],
      searchContent: {
        test: [],
        profile: []
      },
      masterTestAndProfile: {
        test: [],
        profile: []
      },
      isSearchLoading: false,
      searchtext: '',
      result_focus: '',
      locationList: [],
      locationMasterList: [],
      selectedCity: undefined,
      locality: '',
      pincode: '',
      pincodeError: false,
      onBlurKey: false,
      query: undefined,
      sortBy: 1,
      lowestCost: undefined,
      currentLocation: null,
      locationAllowed: false,
      locationChanged: false,
      popularTests: {},
      sideBannerAds: []
    }
  },
  mounted: function () {
    this.$root.$on('removeProfileAndTest', (selectedProfileAndTest) => {
      this.selectedProfileAndTest = selectedProfileAndTest
      this.getLab()
    })
    $('body').click(function (e) {
      if (e.target.id === 'test-option' || $(e.target).parents('#test-option').length) {
      } else {
        this.searchtext = ''
      }
      if (e.target.id === 'localitySearch' || $(e.target).parents('#localitySearch').length) {
      } else {
        this.onBlurKey = false
        this.query = this.locality ? this.locality.locationName : ''
      }
    }.bind(this))
  },
  watch: {
    locationAllowed: function () {
      // this.geolocation()
    }
  },
  created () {
    if (this.$route.params.city) {
      this.getTestByFilter()
    }
    return false
    // if (this.$localStorage.get('pincode')) {
    //   this.pincode = this.$localStorage.get('pincode')
    // }
    // if (this.$localStorage.get('location')) {
    //   this.locality = this.$localStorage.get('location')
    //   this.query = this.locality.locationName
    // } else {
    //   this.pincodeButton = true
    //   setTimeout(function () {
    //     // this.$refs.pincode.focus()
    //   }.bind(this), 300)
    // }
    // if (this.$localStorage.get('st')) {
    //   this.selectedProfileAndTest = this.$localStorage.get('st')
    // }
    // this.selectedLab = []
    // if (this.$localStorage.get('sl')) {
    //   this.selectedLab = this.$localStorage.get('sl')
    // }

    // this.selectedProfileAndTest = []
    // if (this.$localStorage.get('st')) {
    //   this.selectedProfileAndTest = this.$localStorage.get('st')
    // }
    // this.getLab()
    // this.searchLocation()
  },
  methods: {
    getIncudedTestAndProfile: function(tl) {
      let testCountVal = 0
      
        if(tl.profileTestsCount && tl.profileTestsCount > 0) {
          testCountVal = testCountVal + tl.profileTestsCount
        }
        if(tl.package == 1) {
            if ((tl.includedProfiles && tl.includedProfiles.count > 0)) {
              tl.includedProfiles.data.forEach(function(testObj){
                testCountVal = testCountVal + testObj.ProfileTests.length
              })
            }
        }
        return (testCountVal) ? (testCountVal+' Tests') : ''
        
    },
    getIncudedTestAndProfilePop: function(tl) {
      let testCountVal = 0
        console.log(tl)
        if(tl.testCount && tl.testCount > 0) {
          testCountVal = testCountVal + tl.testCount
        }
        if(tl.package == 1) {
            if ((tl.includedProfiles && tl.includedProfiles.count > 0)) {
              tl.includedProfiles.data.forEach(function(testObj){
                testCountVal = testCountVal + testObj.ProfileTests.length
              })
            }
        }
        return (testCountVal) ? (testCountVal+' Tests') : ''
        
    },
    getIncudedTestAndProfilePopup: function(tl) {
      let profileCountStr = ''  
      if(tl.package == 1) {
          if ((tl.includedProfiles && tl.includedProfiles.count > 0)) {
            profileCountStr = tl.includedProfiles.count + ' Profiles'
          }
      }
      let testCountStr = ''
      if(tl.profileTestsCount && tl.profileTestsCount > 0) {
        testCountStr = tl.profileTestsCount + ' Tests'
      }
      return profileCountStr + ((profileCountStr.length > 0 && testCountStr.length > 0) ? ' & ' : '') + testCountStr
        
    },
    getIncudedTestAndProfilePopular: function(tl) {
      let testCountVal = 0
      if (tl.ProfileTests && tl.ProfileTests.length > 0) {
        testCountVal = testCountVal + tl.ProfileTests.length
      }
      if (tl.package == 1) {
          if ((tl.includedProfiles && tl.includedProfiles.count > 0)) {
            tl.includedProfiles.data.forEach(function(testObj){
              testCountVal = testCountVal + testObj.ProfileTests.length
            })
          }
      }
      return (testCountVal) ? (testCountVal+' Tests') : ''
    },
    geolocation: function () {
      var options = {
        maximumAge:60000, 
        timeout:5000, 
        enableHighAccuracy:true
      }
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log('im tracking you!')
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
        this.changeCityUsingLocation()
        return false
      }.bind(this), function (error) {
        if (error.code === error.PERMISSION_DENIED) {
          console.log('you denied me :-(')
          this.locationAllowed = false
          if(!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity)
          }
        }
      }.bind(this)),
      options
    },
    changeCityUsingLocation: function () {
      var data = {
        coordinates : this.currentLocation
      }
      Promise.resolve(this.$POST('patient/getCityUsingLocation', data)).then(function (res) {
        if (res.response_code === 0) {
          if(!this.$localStorage.get('sc')) {
            this.locationMasterList.forEach(function (city) {
              if (res.response.cityId === city.cityId) {
                if(this.selectedCity.cityId !== city.cityId) {
                  this.selectedCity = city
                  this.$localStorage.set('sc', this.selectedCity)
                  this.selectBannerAds()
                  this.locationList = city.ActiveLocation
                  this.selectedCity.ActiveLocation.forEach(function(loc){
                    if(res.response.locationId === loc.locationId) {
                      this.locality = loc
                      this.pincode = loc.locationZipCode
                      this.query = loc.locationName
                      this.$localStorage.set('location', loc, 0)
                      this.$localStorage.set('pincode', this.pincode, 0)
                    }
                  }.bind(this))
                  this.onCityChange()
                } else {
                  if(!this.$localStorage.get('location')) {
                    this.selectedCity.ActiveLocation.forEach(function(loc){
                      if(res.response.locationId === loc.locationId) {
                        this.locality = loc
                        this.pincode = loc.locationZipCode
                        this.query = loc.locationName
                        this.$localStorage.set('location', loc, 0)
                        this.$localStorage.set('pincode', this.pincode, 0)
                      }
                    }.bind(this))
                  }
                }
                this.getLab()
              }
            }.bind(this))
          } else if(!this.$localStorage.get('location')) {
            this.selectedCity.ActiveLocation.forEach(function(loc){
              if(res.response.locationId === loc.locationId) {
                this.locality = loc
                this.pincode = loc.locationZipCode
                this.query = loc.locationName
                this.$localStorage.set('location', loc, 0)
                this.$localStorage.set('pincode', this.pincode, 0)
                this.$router.push('/labs/'+this.selectedCity.cityName+'/'+this.$route.params.test+'/'+loc.locationName)
              }
            }.bind(this))
            this.getLab()
          }
          if(!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity)
          }
        } else {
          if(!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity)
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    getLocation: function () {
      var data = {
        currentLocation: this.currentLocation,
        locationAllowed: this.locationAllowed
      }
      Promise.resolve(this.$POST('patient/getCityAndLocation', data)).then(function (res) {
        console.log(res)
        if (res.response_code === 0) {
          this.locationMasterList = res.response
          if (this.selectedCity) {
            this.locationMasterList.forEach(function (city) {
              if (this.selectedCity.cityId === city.cityId) {
                this.selectedCity = city
                this.$localStorage.set('sc', this.selectedCity)
                this.selectBannerAds()
                this.locationList = city.ActiveLocation
              }
            }.bind(this))
          } else {
            if (this.locationMasterList.length > 0) {
              this.selectedCity = this.locationMasterList[0]
              this.$localStorage.set('sc', this.selectedCity)
              this.selectBannerAds()
              this.locationList = this.locationMasterList[0].ActiveLocation
            } else {
              this.selectedCity = undefined
              this.locationList = []
            }
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    getPopularTest: function () {
      var data = {
        selectedProfileAndTest: this.selectedProfileAndTest
      }
      Promise.resolve(this.$POST('patient/getPopularTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          this.popularTests = res.response
          this.$hidePageLoading()
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    labSortOrder: function () {
      if (this.sortBy === '1') {
        this.labLists.sort(function (a, b) {
          a = a.ourCost
          b = b.ourCost
          return a < b ? -1 : 1
        })
      } else if (this.sortBy === '2') {
        this.labLists.sort(function (a, b) {
          a = a.ourCost
          b = b.ourCost
          return a > b ? -1 : 1
        })
      } else if (this.sortBy === '3') {
        this.labLists.sort(function (a, b) {
          a = a.rating
          b = b.rating
          return a > b ? -1 : 1
        })
      }
      // this.getLab()
    },
    adsRedirect: function (url) {
      if (this.pincode && this.pincode.length === 6) {
        url = url + '/' + this.locality.locationName
      }
      window.open(url, '_blank')
    },
    getTestByFilter: function (type) {
      let testsArr = []
      if(this.$route.params.test && this.$route.params.test.length > 0) {
        let testKeyArray = this.$route.params.test.split('&')
        testKeyArray.forEach(function(testName) {
          let testNameData = testName ? testName.split('_').join(' ') : ''
          testsArr.push(testNameData)
        })
      }
      var locationKey = this.$route.params.location ? this.$route.params.location.split('_').join(' ') : ''
      var data = {
        'city': this.$route.params.city ? this.$route.params.city : '',
        'location': this.$route.params.location ? locationKey : undefined,
        'test': testsArr
      }
      this.$localStorage.remove('sc')
      this.$localStorage.remove('location')
      this.$localStorage.remove('pincode')
      this.$localStorage.remove('st')
      Promise.resolve(this.$POST('patient/getTestByFilter', data)).then(function (res) {
        // this.geolocation()
        this.getLocation()
        if (res.response_code === 0) {
          if (res.response.city && res.response.city != null) {
            this.selectedCity = res.response.city
            this.$localStorage.set('sc', this.selectedCity)
            this.selectBannerAds()
            if (res.response.city.ActiveLocation && res.response.city.ActiveLocation.length > 0) {
              this.$localStorage.set('location', res.response.city.ActiveLocation[0])
              this.$localStorage.set('pincode', res.response.city.ActiveLocation[0].locationZipCode)
              this.closePopup(0)
            } else {
              this.geolocation()
              if (!this.$localStorage.get('ftp')) {
                this.$localStorage.set('ftp', 'YES', 0)
                $('.carousel').carousel({
                  interval: 2000
                })
                // $('html').css({"position":"fixed", "width":"100%"})
                setTimeout(function () {
                  $('.flash-message').css('opacity', '1')
                  $('.black-overlay').css('opacity', '1')
                }, 1000)
              } else {
                // this.$localStorage.remove('ftp')
                this.closePopup(0)
              }
            }
          }
          // if (res.response.location && res.response.location != null) {
          //   // this.$localStorage.set('location',res.response.location)
          //   // this.$localStorage.set('pincode', res.response.location.locationZipCode)
          //   // this.closePopup(0)
          // } else {
          //   if (!this.$localStorage.get('ftp')) {
          //     this.$localStorage.set('ftp','YES',0)
          //     $('.carousel').carousel({
          //       interval: 2000
          //     })
          //     // $('html').css({"position":"fixed", "width":"100%"})
          //     setTimeout(function () {
          //       $('.flash-message').css("opacity", "1")
          //       $('.black-overlay').css("opacity", "1")
          //       // this.$refs.pincodePopup.focus()
          //     }.bind(this), 1000)
          //   } else {
          //     // this.$localStorage.remove('ftp')
          //     this.closePopup(0)
          //   }
          // }
          if (res.response.selectedTest && res.response.selectedTest.length > 0) {
            this.selectedProfileAndTest = []
            document.title = res.response.selectedTest[0].name + ' - Labotist'
            this.selectedProfileAndTest = res.response.selectedTest
            this.$localStorage.set('st', this.selectedProfileAndTest)
            this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest)
            this.getLab(res.response.selectedTest.name)
          } else {
            this.selectedLab = []
            this.labSearchContent = 'No labs found in your searched locations.'
            this.$localStorage.remove('sl')
          }
          this.afterCreate()
          this.getPopularTest()
          this.getAllProfileAndTests()
        }
        this.$hidePageLoading()
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    closePopup: function (type) {
      if (type === 1) {
        if (!this.pincode || this.pincode.length !== 6) {
          this.showLocalityError = true
          return false
        }
      }
      if (type === 2) {
        this.query = undefined
        // $('html').css({"position":"relative", "width":"100%"})
      }
      if (type === 3) {
        // $('html').css({"position":"relative", "width":"100%"})
      }
      $('.flash-message').addClass('bounce')
      $('.black-overlay').css('opacity', '0')
      setTimeout(function () {
        $('.flash-message').css('opacity', '0')
        $('.flash-message').css('bottom', '-500px')
        $('.black-overlay').css('display', 'none')
        setTimeout(function () {
          $('.flash-message').css('display', 'none')
        }, 400)
      }, 400)
    },
    afterCreate: function () {
      if (this.$localStorage.get('pincode')) {
        this.pincode = this.$localStorage.get('pincode')
      }
      if (this.$localStorage.get('location')) {
        this.locality = this.$localStorage.get('location')
        this.query = this.locality.locationName
      } else {
        this.pincodeButton = true
        // setTimeout(function () {
        //   this.$refs.pincodePopup.focus()
        // }.bind(this), 300)
      }
    },
    loadMore: function () {
      var increamented = this.labLimit + 10
      this.labLimit = increamented > this.labLists.length ? this.labLists.length : increamented
    },
    goSearch: function () {
      this.$router.push({ path: '/lab' })
    },
    goChooseDate: function (lab) {
      if (!this.locality || !this.selectedCity) {
        let confirmFn = function () {
          setTimeout(function () {
            this.$refs.pincode.focus()
          }.bind(this), 300)
        }.bind(this)
        this.$Simplert.open({
          title: 'Information',
          message: 'Please choose your nearest locality',
          type: 'warning',
          useConfirmBtn: false,
          onClose: confirmFn,
          customCloseBtnText: 'Ok',
          disableOverlayClick: true,
          showXclose: true
        })
        return false
      }
      this.$localStorage.remove('location')
      this.$localStorage.remove('pincode')
      this.$localStorage.remove('sc')
      this.$localStorage.set('location', this.locality)
      this.$localStorage.set('pincode', this.locality.locationZipCode)
      this.$localStorage.set('sc', this.selectedCity)

      this.$localStorage.remove('ct')
      this.$localStorage.remove('cou')
      if (this.$localStorage.get('sl')) {
        if (this.$localStorage.get('sl').labId !== lab.labId) {
          this.$localStorage.remove('ct')
        }
      }
      this.selectedLab = lab
      this.$localStorage.set('sl', lab, 30 * 60 * 1000)
      this.$localStorage.set('st', this.selectedProfileAndTest)
      Vue.analytics.fbq.event('ViewContent', {
        content_ids: lab.labId,
        content_name: lab.labName,
        contents: {
          id: lab.labId,
          name: lab.labName
        },
        content_type: 'LAB'
      })
      this.$router.push({ path: '/appointment' })
    },
    openProfileTestList: function (profileName, testinfo, tl) {
      this.clickedProfileDetails = {}
      this.clickedProfileTests = []
      this.clickedProfileName = profileName
      this.clickedProfileDetails = tl
      this.clickedProfileTestFirst = []
      this.clickedProfileTestSecond = []
      if (tl.testNames) {
        this.clickedProfileTests = (tl.testNames).split(',')
        let profileCount = this.clickedProfileDetails.includedProfiles ? this.clickedProfileDetails.includedProfiles.count : 0
        let testCount = this.clickedProfileTests.length
        let totalCount = profileCount + testCount
        if (totalCount > 8) {
          if (totalCount > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2 - profileCount)
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2 - profileCount, this.clickedProfileTests.length)
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests
        }
      }
      $('#lab_test-popup').modal('show')
      // this.clickedProfileTests = (tl.testNames)
    },
    openPopularProfileTestList: function (profile) {
      profile['testCount'] = profile.ProfileTests ? profile.ProfileTests.length : 0
      profile['aliasName'] = profile.name
      this.clickedProfileDetails = []
      this.clickedProfileTests = []
      this.clickedProfileName = profile.name
      this.clickedProfileDetails = profile
      this.clickedProfileTestFirst = []
      this.clickedProfileTestSecond = []
      if (profile.ProfileTests) {
        this.clickedProfileTests = profile.ProfileTests
        if (this.clickedProfileTests.length > 8) {
          if (this.clickedProfileTests.length > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2)
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2, this.clickedProfileTests.length)
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests
        }
      }
      $('#test-popup').modal('show')
    },
    getLab: function (selectedTestName) {
      this.labContent = false
      this.ProfileAndTest = []
      this.labLists = []
      this.isLabLoading = true
      var data = {
        'zipCode': this.$localStorage.get('pincode'),
        'locality': this.$localStorage.get('location') ? this.$localStorage.get('location') : null,
        'locationCoordinate': this.$localStorage.get('location') ? this.$localStorage.get('location').locationCoordinate : null,
        'sortBy': this.sortBy,
        'city': this.selectedCity
      }
      var test = []
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.testId > 0) {
            test.push(element.testId)
          }
        }, this)
      }
      data.test = test

      var profile = []
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.panelId > 0) {
            profile.push(element.panelId)
          }
        }, this)
      }
      data.profile = profile
      Promise.resolve(this.$POST('patient/getLab', data)).then(function (res) {
        if (res.response_code === 0) {
          this.isLabLoading = false
          this.s3BucketUrl = this.$_s3BucketUrl
          this.labContent = true
          if (res.response.labList.length > 0) {
            this.labLists = res.response.labList
            this.lowestCost = res.response.lowestCost
            if(selectedTestName) {
              let description = `Book ${selectedTestName}, Starting from Rs.${res.response.lowestCost} in ${this.$localStorage.get('location')?this.$localStorage.get('location').locationName : this.selectedCity.cityName}. Hygienic and top notch home sample collection`
              this.appendMetaTag(description)
            }
          } else {
            this.selectedLab = []
            this.labSearchContent = 'No labs found in your searched locations.'
            this.$localStorage.remove('sl')
          }
        } else {
          this.isLabLoading = false
          this.selectedLab = []
          this.labSearchContent = 'No labs found in your searched locations.'
          this.$localStorage.remove('sl')
        }
        this.$hidePageLoading()
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    appendMetaTag: function(description){
      let metatag = document.head.querySelector("meta[name='description']");
      if (metatag) {
        metatag.content = description
      }
      let ogmetatag = document.head.querySelector("meta[property='og:description']");
      if (ogmetatag) {
        ogmetatag.content = description
      }
    },
    getLabDetails: function (lab) {
      try {
        this.labDetails = ''
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'labId': lab.labId
          }
          Promise.resolve(this.$POST('patient/getLabDetails', data)).then(function (res) {
            if (res.response_code === 0) {
              this.labDetails = res.response
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    clearProfileAndTests: function () {
      this.searchContent = {
        test: [],
        profile: []
      }
    },
    getAllProfileAndTests: function () {
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      }
      Promise.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result'
          } else {
            this.masterTestAndProfile = {
              test: res.response.test,
              profile: res.response.profile
            }
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    getProfileAndTests_old: function () {
      // this.searchContent = ''
      this.isSearchLoading = 'Loading...'
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      }
      Promise.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result'
          } else {
            this.isSearchLoading = false
            let test = res.response.test.sort(this.testSort)
            let profile = res.response.profile.sort(this.testSort)
            // test = test.sort(this.profileSort)
            // profile = profile.sort(this.profileSort)
            this.searchContent = {
              test: test,
              profile: profile
            }
            console.log(this.searchContent)
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    getProfileAndTests: function () {
      this.isSearchLoading = 'Loading...'
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      }
      this.isSearchLoading = 'Loading...'
      let profileOptions = {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        // distance: 20,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "name",
          "Keywords",
          "ProfileTests"
        ]
      };

      var testFuse = new Fuse(this.masterTestAndProfile.test, profileOptions); // "list" is the item array

      var profileFuse = new Fuse(this.masterTestAndProfile.profile, profileOptions); // "list" is the item array
      this.searchContent = {
        test: testFuse.search(this.searchtext),
        profile: profileFuse.search(this.searchtext)
      }
      this.isSearchLoading = false
    },
    testSort: function (a, b) {
      a = a.name.toUpperCase()
      b = b.name.toUpperCase()
      if (a.indexOf(this.searchtext.toUpperCase()) === -1) {
        return 1
      } else if (b.indexOf(this.searchtext.toUpperCase()) === -1) {
        return -1
      }
      return (a.indexOf(this.searchtext.toUpperCase()) < b.indexOf(this.searchtext.toUpperCase())) ? -1 : 1
    },
    addTestFromDropdown: function (event, test) {
      if (test.isSelected === 1) {
        return false
      }
      if (test.testId === 0) {
        this.addTestAndProfile(test)
      } else {
        var filterProfile = []
        _.each(this.selectedProfileAndTest, function (ele, key) {
          if (ele.testId === 0) {
            filterProfile.push(ele)
          }
        })
        if (filterProfile.length > 0) {
          var LabProfileTestsCount = 0
          var splitArrayCount = 0
          var isExistsCount = 0
          var ExistsArray = []
          _.each(filterProfile, function (value, key) {
            if (value.LabProfileTests && value.LabProfileTests !== '') {
              var splitArray = value.LabProfileTests.split(',').map(function (item) {
                return item.trim().toUpperCase()
              })
              if (splitArray.indexOf((test.name).toUpperCase()) === '-1') {
                splitArrayCount++
              } else {
                isExistsCount++
                ExistsArray.push(value.name)
              }
            } else {
              LabProfileTestsCount++
            }
          })
          if (LabProfileTestsCount === filterProfile.length) {
            this.addTestAndProfile(test)
          } else if (splitArrayCount === filterProfile.length) {
            this.addTestAndProfile(test)
          } else if (isExistsCount > 0) {
            let confirmFn = function () {
              this.addTestAndProfile(test, true)
            }.bind(this)

            this.$Simplert.open({
              title: 'Confirm',
              message: `The test that you have selected is already included in one of the profile added to the cart” Just have ok button, no need for cancel.`,
              type: 'info',
              useConfirmBtn: true,
              onConfirm: confirmFn,
              customConfirmBtnText: 'Ok',
              customCloseBtnText: 'Cancel',
              disableOverlayClick: true
            })
          } else {
            this.addTestAndProfile(test)
          }
        } else {
          this.addTestAndProfile(test)
        }
      }
    },
    addTestAndProfile: function (test, isPopup) {
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('cou')
      if (_.pluck(this.selectedProfileAndTest, 'name').indexOf(test.name) === -1) {
        this.selectedProfileAndTest.push(test)
        if (isPopup) {
          this.$apply(function () {
            this.selectedProfileAndTest = _.uniq(this.selectedProfileAndTest)
          })
        } else {
          this.selectedProfileAndTest = _.uniq(this.selectedProfileAndTest)
        }
        let testFB = {
          id: test.testId === 0 ? test.panelId : test.testId,
          isTest: test.testId === 0 ? 0 : 1,
          name: test.name
        }
        if (test.testId === 0) {
          Vue.analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'PROFILE'
          })
        } else {
          Vue.analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'TEST'
          })
        }
        this.$localStorage.set('st', this.selectedProfileAndTest)
        this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest)
      }
      this.searchtext = ''
      // this.getLab()
      // this.getPopularTest()
      this.$router.push({ path: '/lab' })
    },
    removeSelectedItems: function (items) {
      var index = this.selectedProfileAndTest.indexOf(items)
      this.selectedProfileAndTest.splice(index, 1)
      this.$localStorage.set('st', this.selectedProfileAndTest, 0)
      this.$localStorage.remove('cou')
      if (this.selectedProfileAndTest.length === 0) {
        this.$localStorage.remove('sl')
        this.$localStorage.remove('ct')
      }
      let lab = this.$localStorage.get('sl')
      let labTests = []
      this.$localStorage.remove('sl')
      if (lab) {
        lab.labTestList.forEach(function (labTest) {
          if (!((items.testId === labTest.testId && labTest.testId !== 0) || (items.panelId === labTest.panelId && labTest.panelId !== 0))) {
            labTests.push(labTest)
          }
        })
        lab.labTestList = labTests
      }
      this.$localStorage.set('sl', lab, 30 * 60 * 1000)

      this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest)
      // this.getLab()
      // this.getPopularTest()
      this.$router.push({ path: '/lab' })
    },
    searchLocation: function () {
      // this.onBlurKey = true
      this.locality = undefined
      this.pincode = undefined
      let pincode = this.$localStorage.get('pincode')
      this.$localStorage.remove('location')
      this.$localStorage.remove('pincode')
      if (pincode) {
        this.getLab()
      }

      // if (this.query.length < 3) {
      //   this.onBlurKey = false
      //   this.locationList = []
      //   return false
      // }
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'keyword': ''
          }
          Promise.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            console.log(res)
            if (res.response_code === 0) {
              this.locationList = res.response
              this.locationMasterList = res.response
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    onCityChange: function () {
      let localityCheck = undefined
      this.$localStorage.set('sc', this.selectedCity)
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('cou')
      this.selectBannerAds()
      this.selectedCity.ActiveLocation.forEach(function (location) {
        if (this.locality && this.locality.locationId === location.locationId) {
          localityCheck = location
        }
      }.bind(this))
      if (!localityCheck) {
        this.locality = undefined
        this.pincode = ''
        this.query = ''
        this.$localStorage.remove('location')
        this.$localStorage.remove('pincode')
      }
      // this.getLab()
      this.$router.push({ path: '/lab' })
    },
    locationFilterAlphabet: function (a, b) {
      a = a.locationName
      b = b.locationName
      if(a < b) return -1;
      if(a > b) return 1;
      return 0;
    },
    locationFilter: function (a, b) {
      a = a.locationName.toUpperCase()
      b = b.locationName.toUpperCase()
      if (a.indexOf(this.query.toUpperCase()) === -1) {
        return 1
      } else if (b.indexOf(this.query.toUpperCase()) === -1) {
        return -1
      }
      return (a.indexOf(this.query.toUpperCase()) < b.indexOf(this.query.toUpperCase())) ? -1 : 1
    },
    showHideLocation: function () {
      this.onBlurKey = true
      if (this.query.length === 0) {
        this.locationList = this.selectedCity.ActiveLocation.sort(this.locationFilterAlphabet)
      } else {
        let locationFilter = this.selectedCity.ActiveLocation.filter(function (locationVal) {
          let locality = locationVal.locationName
          if (!locality) return false
          locality = locality.toLowerCase()
          return locality.includes(this.query.toLowerCase())
        }.bind(this))
        this.locationList = locationFilter.sort(this.locationFilter)
      }
    },
    closeBlock: function () {
      this.pincodeButton = false
      // setTimeout(function () {
      //   this.onBlurKey = false
      // }.bind(this), 300)
    },
    closeBlockTest: function () {
      setTimeout(function () {
        this.searchtext = ''
      }.bind(this), 300)
    },
    selectLocation: function (obj) {
      this.locality = undefined
      this.locality = obj
      this.pincode = obj.locationZipCode
      this.query = obj.locationName
      // this.locationList = []
      this.onBlurKey = false
      Vue.analytics.fbq.event('ViewContent', {
        content_ids: this.locality.locationId,
        content_name: this.locality.locationZipCode,
        contents: {
          id: this.locality.locationId,
          location: this.locality.locationName,
          zipcode: this.locality.locationZipCode
        },
        content_type: 'PINCODE_ENTERED'
      })
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('cou')
      this.$localStorage.remove('location')
      this.$localStorage.set('location', this.locality, 0)
      this.$localStorage.remove('pincode')
      this.$localStorage.set('pincode', this.locality.locationZipCode, 0)
      // this.getLab()
      this.$router.push('/lab')
    },
    selectBannerAds: function () {
      if (this.selectedCity.cityId === 2) {
        let city = this.selectedCity.cityName
        city = city.toLowerCase()
        this.sideBannerAds = [{
          url: '/labs/' + city + '/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/' + city + '/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/' + city + '/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }, {
          url: '/labs/' + city + '/thyroid_function_test_tft',
          src: 'static/images/banner/loosing.jpg'
        }, {
          url: '/labs/' + city + '/thyroid_function_test_advance',
          src: 'static/images/banner/eating.jpg'
        }]
      } else if (this.selectedCity.cityId === 33) {
        let city = this.selectedCity.cityName
        city = city.toLowerCase()
        this.sideBannerAds = [{
          url: '/labs/' + city + '/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/' + city + '/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/' + city + '/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }, {
          url: '/labs/' + city + '/thyroid_function_test_tft',
          src: 'static/images/banner/loosing.jpg'
        }, {
          url: '/labs/' + city + '/thyroid_function_test_advance',
          src: 'static/images/banner/eating.jpg'
        }]
      } else {
        this.sideBannerAds = []
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.badge .material-icons {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/web/Book/LabLocation.vue